import { GameReelsProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameReelsProperties";
/**
 * ReelsPortraitProperties.ts
 */
export class ReelsPortraitProperties extends GameReelsProperties {
    constructor() {
        super();
        this.position.set(142, 1445);
    }
}
//# sourceMappingURL=ReelsPortraitProperties.js.map